import { render, staticRenderFns } from "./InquiryDetailComment.vue?vue&type=template&id=79edc26c&scoped=true&"
import script from "./InquiryDetailComment.vue?vue&type=script&lang=js&"
export * from "./InquiryDetailComment.vue?vue&type=script&lang=js&"
import style0 from "./InquiryDetailComment.vue?vue&type=style&index=0&id=79edc26c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79edc26c",
  null
  
)

export default component.exports